import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

interface CompanyCard {
  title: string;
  description: string;
  icon: string;
}

@Component({
    selector: 'app-company-section',
    imports: [
    TranslateModule,
    AnimateOnScrollDirective
],
    templateUrl: './company-section.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./company-section.component.scss']
})
export class CompanySectionComponent {
  companyCards: CompanyCard[] = [
    {
      title: 'company.VISION',
      description: 'company.VISION_DESCRIPTION',
      icon: 'assets/images/group-11.svg'
    },
    {
      title: 'company.MISSION',
      description: 'company.MISSION_DESCRIPTION',
      icon: 'assets/images/group-111.svg'
    },
    {
      title: 'company.VALUES',
      description: 'company.VALUES_DESCRIPTION',
      icon: 'assets/images/group-112.svg'
    },
    {
      title: 'company.PURPOSES',
      description: 'company.PURPOSES_DESCRIPTION',
      icon: 'assets/images/group-113.svg'
    }
  ];
} 